import api from './api'

export interface Tenant {
  id: string
  name: string
  createdAt: string
  updatedAt: string
}

export interface TenantWithStats extends Tenant {
  shippersCount: number
  freightForwardersCount: number
  usersCount: number
  processesTotal?: number
  processesInProgress?: number
  processesCompleted?: number
}

export interface CreateTenantData {
  name: string
}

/**
 * Create a new tenant
 */
export async function createTenant(data: CreateTenantData): Promise<Tenant> {
  const response = await api.post('/tenants', data)
  return response.data
}

/**
 * List all tenants
 */
export async function listTenants(): Promise<Tenant[]> {
  const response = await api.get('/tenants')
  return response.data
}

/**
 * List all tenants with stats (companies count, users count)
 */
export async function listTenantsWithStats(): Promise<TenantWithStats[]> {
  const response = await api.get('/tenants?withStats=true')
  return response.data
}

/**
 * Get tenant by ID
 */
export async function getTenant(id: string): Promise<Tenant> {
  const response = await api.get(`/tenants/${id}`)
  return response.data
}

/**
 * Get tenant by ID with stats
 */
export async function getTenantWithStats(id: string): Promise<TenantWithStats> {
  const response = await api.get(`/tenants/${id}?withStats=true`)
  return response.data
}
